/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".svgViewer[_ngcontent-%COMP%]{position:fixed;z-index:1;width:100vw;height:calc(100vh - 64px);left:0;top:64px;overflow:visible}.fabber-sidebar[_ngcontent-%COMP%]{min-width:250px;position:fixed;top:64px;right:0;height:calc(100vh - 64px);z-index:999;background:#2a3f49;color:#fff;transition:all .3s}.fabber-top-overlay[_ngcontent-%COMP%]{position:fixed;top:64px;z-index:200;left:0}.fabber-sidebar-row[_ngcontent-%COMP%]{padding-top:20px;padding-bottom:20px;border-bottom:dashed #3f5f63}"];
export { styles as styles };
